import { render, staticRenderFns } from "./PsFilters.vue?vue&type=template&id=e345c90c"
import script from "./PsFilters.vue?vue&type=script&lang=js"
export * from "./PsFilters.vue?vue&type=script&lang=js"
import style0 from "./PsFilters.vue?vue&type=style&index=0&id=e345c90c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports